@if (cart$ | async; as cart) {
  @if (entries$ | async; as entries) {
    @if (cart.totalItems > 0) {
      <div class="cart-details-wrapper">
        <div class="row">
          <div class="col-6 col-sm-6">
            <h4 class="cx-total">
              {{ 'uigCartDetails.cartName' | cxTranslate: { code: cart.code } }}
            </h4>
          </div>
          <div class="col-3 col-sm-4 total">
            {{ 'orderCost.total' | cxTranslate }}
          </div>
          <div class="col-3 col-sm-2 amount">
            {{ cart.totalPriceWithTax?.formattedValue }}
          </div>
        </div>
        <app-uig-grouped-cart-item-list [cartId]="cart.code" [cartIsLoading]="!(cartLoaded$ | async)"
        [promotionLocation]="promotionLocation" [readonly]="isRestricted" [options]="{
            isSaveForLater: false,
            optionalBtn: saveForLaterBtn
          }" [vendorEntryGroups]="(vendorEntryGroups$ | async)"></app-uig-grouped-cart-item-list>
        <!-- <cx-promotions
          [promotions]="
            (cart.appliedOrderPromotions || []).concat(
              cart.potentialOrderPromotions || []
            )
          "
      ></cx-promotions> -->
    </div>
  }
}
}

<ng-template let-ctx #saveForLaterBtn>
  @if (selectiveCartEnabled) {
    <div class="col-md-3 col-lg-3 col-xl-3 cx-sfl-btn">
      <button class="link cx-action-link" [disabled]="ctx.loading" (click)="saveForLater(ctx.item)" type="button">
        {{ 'saveForLaterItems.saveForLater' | cxTranslate }}
      </button>
    </div>
  }
</ng-template>